import React, { memo } from 'react'

interface LockIconProps {
  size?: number
  className?: string
}

export const LockIcon: React.FC<LockIconProps> = memo(
  ({ size = 16, className }) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M4.00033 14.666C3.63366 14.666 3.31977 14.5355 3.05866 14.2743C2.79755 14.0132 2.66699 13.6993 2.66699 13.3327V6.66602C2.66699 6.29935 2.79755 5.98546 3.05866 5.72435C3.31977 5.46324 3.63366 5.33268 4.00033 5.33268H4.66699V3.99935C4.66699 3.07713 4.99199 2.29102 5.64199 1.64102C6.29199 0.991016 7.0781 0.666016 8.00033 0.666016C8.92255 0.666016 9.70866 0.991016 10.3587 1.64102C11.0087 2.29102 11.3337 3.07713 11.3337 3.99935V5.33268H12.0003C12.367 5.33268 12.6809 5.46324 12.942 5.72435C13.2031 5.98546 13.3337 6.29935 13.3337 6.66602V13.3327C13.3337 13.6993 13.2031 14.0132 12.942 14.2743C12.6809 14.5355 12.367 14.666 12.0003 14.666H4.00033ZM8.00033 11.3327C8.36699 11.3327 8.68088 11.2021 8.94199 10.941C9.2031 10.6799 9.33366 10.366 9.33366 9.99935C9.33366 9.63268 9.2031 9.31879 8.94199 9.05768C8.68088 8.79657 8.36699 8.66602 8.00033 8.66602C7.63366 8.66602 7.31977 8.79657 7.05866 9.05768C6.79755 9.31879 6.66699 9.63268 6.66699 9.99935C6.66699 10.366 6.79755 10.6799 7.05866 10.941C7.31977 11.2021 7.63366 11.3327 8.00033 11.3327ZM6.00033 5.33268H10.0003V3.99935C10.0003 3.44379 9.80588 2.97157 9.41699 2.58268C9.0281 2.19379 8.55588 1.99935 8.00033 1.99935C7.44477 1.99935 6.97255 2.19379 6.58366 2.58268C6.19477 2.97157 6.00033 3.44379 6.00033 3.99935V5.33268Z"
        fill="currentColor"
      />
    </svg>
  ),
)
